// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';

// Redux stuff
import { connect } from 'react-redux';

// utilities
import _, { get } from 'lodash';
import cx from 'classnames';
import prettyDate from '../../../../../lib/prettyDate';

// Async actions
import {
  submitContactEvent
} from '../../../../../redux/actionCreators/async';

// components
import EventsList from './EventsList';
import AddTaskForm from './AddTaskForm';
import AddNoteForm from './AddNoteForm';

import CloseX from '../../../../../common/svgs/CloseX';
import ChevronIcon from '../../../../../common/svgs/ChevronIcon';
import Button from '../../../../../common/components/Button';

@connect((store, props) => {
  const contact = get(store.admin, 'contactInContactWorksheet', {});
  const taskTypes=store.staticData.applicantTaskTypeList;
  const noteTypes=store.staticData.contactNoteTypes;
  const taskResultTypes=store.staticData.contactTaskResultTypes;

  return {
    staticData: store.staticData,
    user: store.user,
    contact,
    taskTypes,
    noteTypes,
    taskResultTypes,
    submitContactEvent
  };
})
// gives dispatch function
export default class Events extends Component {
  static propTypes = {
    submitContactEvent: PropTypes.func.isRequired,
    contactId: PropTypes.number.isRequired,
    contact: PropTypes.object.isRequired,
    show: PropTypes.bool,
    style: PropTypes.object,
    taskTypes: PropTypes.array,
    taskResultTypes: PropTypes.array,
    alertsList: PropTypes.array,
    route: PropTypes.object.isRequired
  }

  state = {
    show: 'tasks',
    addEventToggled: false,
    addType: 'task',
    itemId: '',
    editMode: false,
    showNoteDetails: {},
    sortField: 'dateCreated',
    sortDescending: true,
  }

  toggleShow(show) {
    this.state.noteText = '';
    this.state.item = null;
    this.state.addType = 'task';

    if (show === undefined) {
      show = 'tasks';
    }

    this.setState(_.merge({}, this.state, {
      show
    }));
  }

  toggleSort(sortField) {
    if (this.state.sortField === sortField) {
      this.setState(_.merge({}, this.state, {
        sortDescending: !this.state.sortDescending,
      }));
    }
    else {
      this.setState(_.merge({}, this.state, {
        sortField,
        sortDescending: true,
      }));
    }
  }

  toggleAdd() {
    this.setState(_.merge({}, this.state, {
      addEventToggled: !this.state.addEventToggled
    }));
  }

  toggleNoteMessage(index) {
    const showNoteDetails = this.state.showNoteDetails;
    if (_.isNil(showNoteDetails[index])) {
      showNoteDetails[index] = false;
    }
    showNoteDetails[index] = !this.state.showNoteDetails[index];

    this.setState(_.merge({}, this.state, {
      showNoteDetails
    }));
  }

  selectAddType(val) {
    this.setState(_.merge({}, this.state, {
      addType: val
    }));
  }

  submitTask(task) {

    if(this.state.editMode) {
      task.taskId = this.state.itemId;
      this.props.dispatch(this.props.submitContactEvent('tasks', task, {type: 'edit', param: this.state.itemId}));
    }else{
      this.props.dispatch(this.props.submitContactEvent('tasks', task));
    }

    this.state.itemId = '';
    this.state.editMode = false;
    this.state.noteText = '';
    this.state.item = null;
    this.toggleAdd();
  }

  submitNote(note) {

    if(this.state.editMode) {
      note.noteId = this.state.itemId;
      this.props.dispatch(this.props.submitContactEvent('notes', note, {type: 'edit', param: this.state.itemId}));
    }else{
      this.props.dispatch(this.props.submitContactEvent('notes', note));
    }

    this.state.itemId = '';
    this.state.editMode = false;
    this.state.noteText = '';
    this.state.item = null;
    this.toggleAdd();

  }

  handleClick(index, list) {
    if(list[index].type === 'note') {
      this.state.addType = 'note';
      this.state.item = list[index];
      this.state.editMode = true;
      this.toggleAdd();
    }
    else {
      if(list[index].type === 'task') {
        this.state.addType = 'task';
        this.state.item = list[index];
        this.state.itemId = list[index].id;
        this.state.editMode = true;
        this.state.show = list[index].isNote ? 'notes' : 'tasks';
        this.toggleAdd();
      }
    }
  }

  render() {
    // yank vars off state
    const {
      addEventToggled,
    } = this.state;

    // combine event properties and sort by date
    const eventList = _([])
      .concat(_.get(this.props.contact, 'profile.tasks') || [])
      .concat(_.get(this.props.contact, 'profile.notes') || [])
      .concat(_.get(this.props.contact, 'profile.notifications') || [])
      .orderBy(['dateCreated'], ['desc'])
      .orderBy([this.state.sortField], [this.state.sortDescending ? 'desc' : 'asc'])
      .value();

    const alertsStyle = {
      height: global.innerHeight - 50
    };


    // TODO: Reserved if client wants to associate notes to sections.
    let  catgoryDescription = 'Profile';

    return (
      <div className={cx('contact-worksheet-events', 'clearfix', {'hide-note': !(this.state.show === 'notes' || this.state.show === 'all'), 'hide-task': !(this.state.show === 'tasks' || this.state.show === 'all') })} style = { alertsStyle } >
        <div className='alerts-nav'>
          <div data-id='Tasks'
               className={cx('alerts-nav-item', {'selected': this.state.show === 'tasks'})}
               onClick={this.toggleShow.bind(this, 'tasks')}>
            <div className='alerts-nav-text'>
              Tasks
            </div>
          </div>
          <div data-id='Notes'
               className={cx('alerts-nav-item', {'selected': this.state.show === 'notes'})}
               onClick={this.toggleShow.bind(this, 'notes')}>
            <div className='alerts-nav-text'>
              Notes
            </div>
          </div>

           <div data-id='All'
               className={cx('alerts-nav-item', {'selected': this.state.show === 'all'})}
               onClick={this.toggleShow.bind(this, 'all')}>
            <div className='alerts-nav-text'>
              All
            </div>
          </div>

        </div>
        {
          addEventToggled
          &&
          <div className='add-event-wrapper'>
            <div className='event-heading-wrapper'>
              <div data-id='Add Task' className={cx('add-event-text', 'task', 'noTextSelect', 'active-add')} >
                <CloseX data-id='Close' className='plus noTextSelect add-event-close' onClick={this.toggleAdd.bind(this)} />
              </div>
            </div>
            <div className='add-event-form'>
              <div className='current-date'>
                {prettyDate(new Date())}
              </div>
              {
                this.state.show === 'tasks'
                &&
                <AddTaskForm
                contactId={this.props.contact.profile.id}
                contactStatusId={this.props.contact.profile.contactStatus}
                isNote={false}
                submitTask={::this.submitTask}
                taskTypes={this.props.taskTypes}
                taskResultTypes={this.props.taskResultTypes}
                item={this.state.item}
              />
              }

              {
                this.state.show === 'notes'
                &&
                <AddTaskForm
                contactId={this.props.contact.profile.id}
                contactStatusId={this.props.contact.profile.contactStatus}
                isNote={true}
                submitTask={::this.submitTask}
                taskTypes={this.props.noteTypes}
                taskResultTypes={this.props.taskResultTypes}
                item={this.state.item}
              />
              }

            </div>
          </div>
        }

        <div className={cx('event-container', {toggled: addEventToggled})}>

          {
             this.state.show !== 'all'
              && <div data-id='Add Event'
                className={cx('add-event', {toggled: addEventToggled})}
                onClick={!addEventToggled && this.toggleAdd.bind(this)}>

                 {
                    this.state.show === 'tasks'
                    &&
                    <Button
                      className='button-secondary-full'
                      label={'Add Task'}
                    />
                }

                {
                    this.state.show === 'notes'
                    &&
                    <Button
                      className='button-secondary-full'
                      label={'Add Note'}
                    />
                }

            </div>
          }

          <div className='notes-filter-wrapper'>

            <div className='notes-sort'>
              {
                (this.state.show === 'tasks' || this.state.show === 'all')
                &&
                <div data-id='Follow Up Date' className='sort-field follow-up-date' onClick={this.toggleSort.bind(this, 'taskFollowUpDate')} >Follow Up Date
                  <div className={cx('chevron', {
                        descending: this.state.sortField === 'taskFollowUpDate' && this.state.sortDescending,
                        ascending: this.state.sortField === 'taskFollowUpDate' && !this.state.sortDescending,
                      })}
                   >
                    <ChevronIcon/>
                  </div>
                </div>
              }
              <div data-id='Updated Date' className='sort-field updated-date' onClick={this.toggleSort.bind(this, 'dateCreated')} >Added Date
                <div className={cx('chevron', {
                      descending: this.state.sortField === 'dateCreated' && this.state.sortDescending,
                      ascending: this.state.sortField === 'dateCreated' && !this.state.sortDescending,
                    })}
                >
                  <ChevronIcon/>
                </div>
              </div>
            </div>
          </div>
          <EventsList
            list={eventList}
            state={this.state}
            user={this.props.user}
            category={catgoryDescription}
            contactStatusId={_.get(this.props.contact, 'profile.contactStatus')}
            staticData={this.props.staticData}
            handleClick={this.handleClick.bind(this)}
            toggleNoteMessage={this.toggleNoteMessage.bind(this)}
          />

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Contact/Worksheet/Events/index.js